module.exports = __webpack_public_path__ + "img/allvmcorgchart.2e9b3c89.jpg";